var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-wrapper"},[(_vm.hasSearch)?_c('Search'):_vm._e(),_c('div',{staticClass:"s-container"},[(_vm.hasSearch)?_c('Aside'):_vm._e(),_c('Notices')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }